import { render, staticRenderFns } from "./link-display.vue?vue&type=template&id=571c4757&scoped=true"
import script from "./link-display.vue?vue&type=script&lang=ts&setup=true"
export * from "./link-display.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./link-display.vue?vue&type=style&index=0&id=571c4757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c4757",
  null
  
)

export default component.exports